import { connect } from 'react-redux';
import { authenticateAirbnb } from 'src/store/Auth/actions';
import { default as AirbnbAuthModalRoot } from './AirbnbAuthModal';

const mapStateToProps = ({ airbnbAuth }) => ({
  loading: airbnbAuth.loading,
  action: airbnbAuth.action,
  captcha_url: airbnbAuth.captcha_url,
  airlock_id: airbnbAuth.airlock_id,
  user_id: airbnbAuth.user_id,
  error: airbnbAuth.error,
});

const mapDispatchToProps = {
  authenticateAirbnb,
};

export const AirbnbAuthModal = connect(mapStateToProps, mapDispatchToProps)(AirbnbAuthModalRoot);
